import React from "react";
import CBannerSection from "./cBannerSection";
import CWelcomeSection from "./cWelcomeSection";
import VenueDetailsSection from "./venueDetailsSection";
import ServiceSection from "./serviceSection";
import PrefferedVendor from "./prefferedVendorSection";
import { CVideoSection } from "./cVideoSection";
import { CBlogsection } from "./cBlogsection";
import { CTestimonials } from "./ctestimonials";
import { CAmenitiesSection } from "./cAmenitiesSection";
import { CPackageSection } from "./cPackageSection";
import { CGallerySection } from "./cGallerySection";
import { CVenueHighlightsSection } from "./cVenueHighlightsSection";
import EventTips from "./eventTips";

const CorporatePage = () => {
  return (
    <>
      <CBannerSection id={4} />
      <CWelcomeSection id={4} />
      <VenueDetailsSection />
      <ServiceSection id={4} />
      <PrefferedVendor id={4} />
      <CPackageSection id={4} />
      <CGallerySection id={4} />
      <CVenueHighlightsSection id={4} />
      <CAmenitiesSection id={4} />
      <CTestimonials id={4} />
      <CVideoSection id={4} />
      <CBlogsection id={4} />
      <EventTips id={4} />
    </>
  );
};

export default CorporatePage;
